module.exports = __webpack_public_path__ + "ProximaNova-LightIt.dd4ab75518e9afc8e1a21d0d3b77ffbf.woff2";